// SignupContent Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Recaptcha from 'react-google-recaptcha'

import InputAlt from '../../form/input_alt/input_alt.jsx'
import Select from '../../form/select/select.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import Alert from '../../common/alert/alert.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class SignupContent extends Component {
  static get propTypes () {
    return {
      onSignup: PropTypes.func,
      imageUrl: PropTypes.string,
      onUploadSuccess: PropTypes.func,
      onUploadError: PropTypes.func,
      onDeleteImage: PropTypes.func,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      language: PropTypes.string,
      showLogin: PropTypes.bool,
      recaptchaEnabled: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onSignup: null,
      imageUrl: '',
      onUploadSuccess: null,
      onUploadError: null,
      onDeleteImage: null,
      firstName: '',
      lastName: '',
      email: '',
      language: '',
      showLogin: false,
      recaptchaEnabled: false
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      bPassword: false,
      bAnimateContent: false,
      firstName: props.firstName,
      lastName: props.lastName ? props.lastName : '',
      language: props.language ? props.language : 'EN',
      email: props.email,
      image: '',
      password: '',
      confirmPassword: '',
      errSignup: '',
      bLogin: false,
      loginPassword: '',
      contHgt: null
    }

    this.data = {
      languages: [
        { label: 'user.signup.optionNederlands', value: 'NL' },
        { label: 'user.signup.optionDeutsch', value: 'DE' }
      ]
    }

    if (props.language && props.language === 'US') {
      this.data.languages.push({
        label: 'user.signup.optionEnglish',
        value: 'US'
      })
    } else {
      this.data.languages.push({
        label: 'user.signup.optionEnglish',
        value: 'EN'
      })
    }

    this._references = {
      alert: React.createRef(),
      inputFirstName: React.createRef(),
      inputEmail: React.createRef(),
      inputPassword: React.createRef(),
      inputConfirmPassword: React.createRef(),
      inputLoginPassword: React.createRef()
    }

    this._recaptcha = null
    this._recaptchaEnabled = !!this.props.recaptchaEnabled
  }

  handleResize () {
    const minheight = this.getWindowHeight()
    this.setState({ contHgt: { height: minheight } })
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize.bind(this))
    this.handleResize()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  getWindowHeight () {
    const windowHgt = window.innerHeight + 'px'

    return windowHgt
  }

  showError (msgIdent) {
    if (this._references.alert.current) {
      this._references.alert.current.onShow(
        IntlUtil.convertMessage(msgIdent),
        'error'
      )
    }
  }

  render () {
    const contentClass = classnames('signup-content', {})

    return (
      <div className={contentClass} style={this.state.contHgt}>
        <div className='header'>
          <img
            src='/images/common/signup_logo.png'
            alt='Invoice'
            className='inline-image'
          />
        </div>
        <div className='signupcontainer'>
          <div className='content'>
            {this._renderSignupForm()}
            {this._renderPasswordForm()}
            {this._renderLoginForm()}
          </div>
        </div>
        <Alert ref={this._references.alert} />
      </div>
    )
  }

  showSignupError (message) {
    this.setState({
      errSignup: message || 'user.signup.msgInvalidValues'
    })
  }

  hideSignupError () {
    this.setState({ errSignup: '' })
  }

  /* Event Handlers */
  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onSubmitFirstForm (ev) {
    ev.preventDefault()
    let noErrors = 0

    if (
      this._references.inputFirstName.current &&
      !this._references.inputFirstName.current.validate()
    ) {
      this.setState({ errSignup: 'user.signup.msgInvalidFirstName' })
      noErrors++
    } else if (
      this._references.inputEmail.current &&
      !this._references.inputEmail.current.validate()
    ) {
      this.setState({ errSignup: 'user.signup.msgInvalidEmail' })
      noErrors++
    }

    if (noErrors === 0) {
      this.setState({
        bLogin: true,
        bPassword: !this.props.showLogin,
        errSignup: ''
      })
    }
  }

  _onSubmitSecondForm (ev) {
    ev.preventDefault()
    let noErrors = 0

    if (
      this._references.inputPassword.current &&
      !this._references.inputPassword.current.validate()
    ) {
      if (!this.state.password) {
        this.setState({ errSignup: 'user.signup.msgErrorPassword' })
        this.showError('user.signupTeam.msgErrorPassword')
      } else {
        this.setState({ errSignup: 'user.signup.msgInvalidPassword' })
        this.showError('user.signupTeam.msgInvalidPassword')
      }
      noErrors++
    } else if (
      this._references.inputConfirmPassword.current &&
      !this._references.inputConfirmPassword.current.validate()
    ) {
      if (!this.state.confirmPassword) {
        this.setState({ errSignup: 'user.signup.msgErrorConfirmPassword' })
        this.showError('user.signupTeam.msgErrorConfirmPassword')
      } else {
        this.setState({ errSignup: 'user.signup.msgInvalidConfirmPassword' })
        this.showError('user.signupTeam.msgInvalidConfirmPassword')
      }
      noErrors++
    } else if (this.state.password !== this.state.confirmPassword) {
      this.setState({ errSignup: 'user.signup.msgPasswordNotMatch' })
      this.showError('user.signupTeam.msgPasswordNotMatch')
      noErrors++
    }

    if (noErrors === 0 && this._recaptchaEnabled && this._recaptcha) {
      this._recaptcha.execute()
    } else if (noErrors === 0 && !this._recaptchaEnabled) {
      const user = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        language: this.state.language,
        email: this.state.email,
        image: this.state.image,
        password: this.state.password
      }

      if (this.props.onSignup) {
        this.props.onSignup(user)
      }
    }
  }

  _onSubmitLoginForm (ev) {
    ev.preventDefault()
    let noErrors = 0

    if (
      this._references.inputLoginPassword.current &&
      !this._references.inputLoginPassword.current.validate()
    ) {
      if (!this.state.loginPassword) {
        this.setState({ errSignup: 'user.signup.msgErrorPassword' })
      } else {
        this.setState({ errSignup: 'user.signup.msgInvalidPassword' })
      }
      noErrors++
    }

    /** * DISABLED TEMP if (noErrors === 0 && this._recaptcha) {
       this._recaptcha.execute();
     } */

    if (noErrors === 0) {
      const user = {
        email: this.state.email,
        password: this.state.loginPassword,
        language: this.state.language
      }

      if (this.props.onSignup) {
        this.props.onSignup(user)
      }
    }
  }

  _onCaptchaVerified (_token) {
    const user = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      language: this.state.language,
      email: this.state.email,
      image: this.state.image,
      password: this.state.password
    }

    if (this.props.onSignup) {
      this.props.onSignup(user)
    }
  }

  _onClickPrevious (ev) {
    ev.preventDefault()
    this.setState({ bLogin: false, bPassword: false, errSignup: '' })
  }

  /* Private functions */
  _renderMessage (type, title, content, email) {
    const _clsNames = classnames('formmessage', {
      formmessage_error: type
    })

    return (
      <div className={_clsNames}>
        <h2 className='title'>
          <IntlMessage ident={title} />
        </h2>
        <p className='content'>
          <IntlMessage ident={content} />
          {email}
        </p>
      </div>
    )
  }

  _renderErrorMessage () {
    if (this.state.errSignup) {
      const msg = 'user.signup.msgSignupError'
      return this._renderMessage('error', msg, this.state.errSignup, '')
    }

    return null
  }

  _renderSignupForm () {
    const formClass = classnames('signupform', {
      signupform_show: !this.state.bPassword && !this.state.bLogin,
      signupform_animatecont: this.state.bAnimateContent,
      signupform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitFirstForm.bind(this)}
        >
          <div className='typo'>
            <h1 className='title'>
              <IntlMessage ident='user.signupTeam.signupTitle' />
            </h1>
            <div className='content'>
              <p>
                <IntlMessage ident='user.signupTeam.inviteSubInfo' />
              </p>
            </div>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signup.firstNamePlaceholder' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='firstName'
                  size={10}
                  maxLength={100}
                  label='user.signup.firstNamePlaceholder'
                  ref={this._references.inputFirstName}
                  required
                  validations={['required']}
                  value={this.state.firstName}
                  onChange={this._onChangeInput.bind(this, 'firstName')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signup.lastNamePlaceholder' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='lastName'
                  size={10}
                  maxLength={100}
                  label='user.signup.lastNamePlaceholder'
                  value={this.state.lastName}
                  onChange={this._onChangeInput.bind(this, 'lastName')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signup.languagePlaceholder' />
              </div>
              <div className='formfield'>
                <Select
                  options={this.data.languages}
                  name='language'
                  multilingualOptions
                  label='user.signup.languagePlaceholder'
                  className='signup'
                  icon='signup-downarw'
                  onChange={this._onChangeInput.bind(this, 'language')}
                  value={this.state.language}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signup.emailPlaceholder' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='email'
                  size={10}
                  maxLength={100}
                  label='user.signup.emailPlaceholder'
                  ref={this._references.inputEmail}
                  required
                  validations={['required', 'email']}
                  value={this.state.email}
                  className='disabled'
                  readOnly
                  onChange={this._onChangeInput.bind(this, 'email')}
                />
              </div>
            </div>
          </div>
          <div className='formact'>
            <button type='submit' style={{ display: 'none' }}>
              <IntlMessage ident='user.signup.submit' />
            </button>
            <IconButton
              type='primary'
              size='big'
              icon='signup-next'
              title='user.signupTeam.titleNext'
              className='signup'
              canHover={false}
              onClick={this._onSubmitFirstForm.bind(this)}
            />
          </div>
        </form>
      </div>
    )
  }

  _renderCaptcha () {
    if (this._recaptchaEnabled) {
      return (
        <Recaptcha
          ref={el => {
            this._recaptcha = el
          }}
          size='invisible'
          sitekey='6LdBpyEUAAAAAFPxRsQcCGTzLRtxwnHQPJh5WoU5'
          badge='bottomleft'
          onChange={this._onCaptchaVerified.bind(this)}
        />
      )
    }

    return ''
  }

  _renderPasswordForm () {
    const formClass = classnames('signupform', {
      signupform_show: this.state.bPassword && !this.props.showLogin,
      signupform_animatecont: this.state.bAnimateContent,
      signupform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitSecondForm.bind(this)}
        >
          <div className='typo'>
            <h1 className='title'>
              <IntlMessage ident='user.signupTeam.passwordCreateTitle' />
            </h1>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='typo'>
                <p>
                  <IntlMessage ident='user.signup.passwordHintCharater' />
                  <br />
                  <IntlMessage ident='user.signup.passwordHintAlphanumeric' />
                  <br />
                  <IntlMessage ident='user.signup.passwordHintDigit' />
                  <br />
                  <IntlMessage ident='user.signup.passwordHintSpace' />
                </p>
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signup.passwordPlaceholder' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='password'
                  name='password'
                  size={10}
                  maxLength={100}
                  label='user.signup.passwordPlaceholder'
                  ref={this._references.inputPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.password}
                  onChange={this._onChangeInput.bind(this, 'password')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signup.passwordRepeat' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='password'
                  name='password'
                  size={10}
                  maxLength={100}
                  label='user.signup.passwordRepeat'
                  ref={this._references.inputConfirmPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.confirmPassword}
                  onChange={this._onChangeInput.bind(this, 'confirmPassword')}
                />
              </div>
            </div>
          </div>
          <div className='grecaptchawrap'>{this._renderCaptcha()}</div>
          <div className='formact'>
            <button type='submit' style={{ display: 'none' }}>
              <IntlMessage ident='user.signup.submit' />
            </button>
            <div className='action'>
              <IconButton
                type='primary'
                size='big'
                icon='signup-previous'
                title='user.signup.titlePrevious'
                canHover={false}
                className='previous'
                onClick={this._onClickPrevious.bind(this)}
              />
              <IconButton
                type='primary'
                size='big'
                icon='signup-success'
                title='user.signupTeam.submit'
                className='signup'
                canHover={false}
                onClick={this._onSubmitSecondForm.bind(this)}
              />
            </div>
          </div>
        </form>
      </div>
    )
  }

  _renderLoginForm () {
    const formClass = classnames('signupform', {
      signupform_show: this.state.bLogin && this.props.showLogin,
      signupform_animatecont: this.state.bAnimateContent,
      signupform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitLoginForm.bind(this)}
        >
          <div className='typo'>
            <h1 className='title'>
              <IntlMessage ident='user.signupTeam.loginTitle' />
            </h1>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='typo'>
                <p>
                  <IntlMessage ident='user.signupTeam.loginInfo' />
                </p>
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signup.loginPassword' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='password'
                  name='password'
                  size={10}
                  maxLength={100}
                  label='user.signupTeam.loginPassword'
                  ref={this._references.inputLoginPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.loginPassword}
                  onChange={this._onChangeInput.bind(this, 'loginPassword')}
                />
              </div>
            </div>
          </div>
          <div className='grecaptchawrap'>{this._renderCaptcha()}</div>
          <div className='formact'>
            <button type='submit' style={{ display: 'none' }}>
              <IntlMessage ident='user.signup.submit' />
            </button>
            <div className='action'>
              <IconButton
                type='primary'
                size='big'
                icon='signup-previous'
                title='user.signup.titlePrevious'
                canHover={false}
                className='previous'
                onClick={this._onClickPrevious.bind(this)}
              />
              <IconButton
                type='primary'
                size='big'
                icon='signup-success'
                title='user.signup.submit'
                className='signup'
                canHover={false}
                onClick={this._onSubmitLoginForm.bind(this)}
              />
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default SignupContent
